import { clsx } from "coreutils-js";
import { cloneElement, ReactElement, ReactNode } from 'react';

import './layout.scss';

//@ts-ignore
import { Button } from '@microui/react-ui';
//@ts-ignore
import { MicroIcon } from '@microui/react-icons';

export interface DetailLayoutProps {
    children?: ReactNode;
    /**
     * Danh sách các nút action được render dưới layout bên phải 
     */
    buttons?: ReactElement[];

    buttonPlacement?: 'center' | 'right';

    navigateBack?: () => void;
}

const DetailLayout = ({ children, buttons = [], buttonPlacement = 'center', navigateBack }: DetailLayoutProps) => {
    return (
        <div styleName={clsx('d-layout')} className="h-full w-full relative flex flex-1 flex-col">
            <div className="flex-1 overflow-auto" styleName={clsx('d-layout-main')}>
                {children}
            </div>
            <div
                className={clsx(
                    "relative py-3 px-6 w-full bg-white border-t border-t-gray-600 flex items-center",
                )}
            >
                <div className="z-10">
                    <Button
                        prefix={<MicroIcon icon="chevron-left" theme="outlined" />}
                        onClick={navigateBack}
                    >
                        Trở lại
                    </Button>
                </div>

                <div
                    className={clsx(
                        "absolute w-full flex items-center pr-10",
                        buttonPlacement == 'right' && 'justify-end',
                        buttonPlacement == 'center' && 'justify-center'
                    )}
                >
                    {buttons.map((button, idx) => cloneElement(button, { key: idx }))}
                </div>
            </div>
        </div>
    )
}

export default DetailLayout;
